window.baseURL = window.siteURL + "/condition";
window.queryURL = window.siteURL + "/wp-json/v1/conditions";

function init() {
  const filters = document.querySelectorAll('.c-dropdown__input');
  const button = document.querySelector('.c-search__button');

  if (!filters) {
    return;
  }

  document.querySelectorAll(".c-dropdown__option").forEach(function(option) {
    option.addEventListener('click', function() {
      buildQuery(button);
    });
  });

  document.querySelectorAll(".c-dropdown__trigger").forEach(function(trigger) {
    trigger.addEventListener('click', function() {
        if(trigger.parentNode.classList.contains('open')){
          buildQuery(button);
        }
    });
  });

}

function enableButton(button) {

  const filters = document.querySelectorAll('.c-dropdown__input');
  let filter_select = false;
  Array.from(filters).forEach((filter) => {
    const value = filter.value;
    if(value != "all"){
      filter_select = true;
    }
  });

  if(filter_select) {
    button.removeAttribute("disabled");
  } else {
    button.setAttribute("disabled", "disabled");
  }

}

function buildQuery(button) {

  const queryURL = window.queryURL;
  let queryString = "";
  let pushStateString = "/?";

  const filters = document.querySelectorAll('.c-dropdown__input');
  const s_button = document.querySelectorAll('.c-search__button');
  Array.from(filters).forEach((filter) => {
    const taxonomy = filter.dataset.filter;
    const value = filter.value;
    queryString = queryString + "/" + taxonomy + "/" + value;
    if(value != "all"){
      pushStateString = pushStateString + "&" + taxonomy + "=" + value;
    }
  });

  if(!button){

    let execURL = queryURL + queryString;
    $.ajax({
      url: execURL,
      success: function(data){
        let x = 0;
        let el = "";

        $.each(data, function() {
          let encoded_url = encodeURIComponent(window.location.href);
          let q_permalink = this.permalink + "/?q=" + encoded_url;
          let is_odd = (x % 2 == 0) ? "false" : "true";
          el += "<a class=\"c-card__link\" href=\"" + q_permalink + "\">";
            el += "<h1 class=\"c-card__title\" onmousemove=\"showMenuPreview(this,event," + is_odd + ")\" onmouseout=\"hideMenuPreview(this)\">" + this.title + "</h1>";
            if(this.image) {
              el += "<div class=\"c-card__media preview\">";
                el += "<div class=\"c-media lazyload\" data-background=\"" + this.image + "\"></div>";
              el += "</div>";
            }
          el += "</a>";

          x++;
        });

        $(".c-cards--1up").html(el);
        setTimeout(function() {
            lazySizes.loader.checkElems();
        }, 500);

      },
      error: function(error){
        $(".c-cards--1up").html("<a class=\"c-card__link c-card__no_link\"><h1 class=\"c-card__title\">" + error.responseJSON.message + "</h1></a>");
      }
    });

    window.history.pushState({urlPath: pushStateString}, "", pushStateString);

  } else {

    enableButton(button);
    button.setAttribute('href', window.baseURL + pushStateString);

  }

}

export default init;
